import { Component, OnInit, ViewChild, Output, EventEmitter, Input } from '@angular/core';

import { FormularioOrtodontia } from '../../base/vo/formulario-ortodontia';
import { ItensTabelaPlanejamento } from '../../base/util/itens-tabela-planejamento';
import { ItensDiagnosticoComplementar } from '../../base/util/itens-diagnostico-complementar';

@Component({
    selector: 'resumo-ortodontia',
    templateUrl: './resumo-ortodontia.component.html',
    styleUrls: ['./resumo-ortodontia.component.css']
})
export class ResumoOrtodontiaComponent implements OnInit {

    @Input() formularioOrtodontia: FormularioOrtodontia;
	acordionHeaderIcon: String = "icons-chevron-right";
	private itensPlanejamento = [];
	private itensDiagnosticoComplementar = [];
	private classe = { 1: 'I', 2: 'II', 3: 'III', 4: 'IV', 5: 'V', 6: 'VI'};
	private fase = { P: 'Preventiva', I: 'Interceptiva', C: 'Corretiva', O: 'Ortopédica' };

    constructor() { }

    ngOnInit() {
    	if(this.formularioOrtodontia) {
			this.itensPlanejamento = ItensTabelaPlanejamento.getItensPlanejamento(this.formularioOrtodontia);
			this.itensDiagnosticoComplementar = ItensDiagnosticoComplementar.getItensDiagnostico(this.formularioOrtodontia);
		}
    }

	private getStringMes(mes: number){
		if(mes){
		  let stringMes = mes > 1 ? 'meses' : 'mes';
		  return `${mes} ${stringMes}`
		}
	}

	private getStringClassificacao(nClasse: number){
		if(this.classe[nClasse]) {
	    	return `Classe ${this.classe[nClasse]}`;
	    } else {
	    	return '';
	    }
	}
	
	private getStringFase(fase: string){
	    return this.fase[fase];
	}

}


// WEBPACK FOOTER //
// ./src/app/components/ortodontia/resumo-ortodontia/resumo-ortodontia.component.ts